import "scripts/layout/theme.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("layout.theme");
